// @flow

import * as React from "react";
import { useHistory } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import queryString from "query-string";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

import { customValidators } from "../utils/validators";
import userApi from "../api/user";
import Config from "../constants/Config";
import useAsyncState from "../hooks/useAsyncState";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import Button from "../components/atoms/Button";
import ServerErrorMessage from "../components/atoms/ServerErrorMessage";
import CustomMeta from "../components/atoms/CustomMeta";

const ResetPassword = (): React.Node => {
    const history = useHistory();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [state, localActions] = useAsyncState();
    const queryParamProps = queryString.parse(history.location.search);

    // /profile/reset-password?token={{token}}&login={{user-email}}"

    const handleFormSubmit = async (formData: any): any => {
        if (!executeRecaptcha) {
            localActions.fail("reCAPTCHA is still loading. Please try again.");
            return;
        }

        const googleRecaptchaResponse = await executeRecaptcha(
            "reset_password"
        );

        localActions.request();

        userApi
            .userResetPassword(
                queryParamProps.token,
                queryParamProps.login,
                formData.password,
                googleRecaptchaResponse
            )
            .then(res => {
                localActions.success("Password reset successfully.");
            })
            .catch((error: any) => {
                console.error(error);
                localActions.fail(
                    error.message ||
                        "Something went wrong resetting your password."
                );
            });
    };

    return (
        <React.Fragment>
            <CustomMeta title="Reset Password" />

            <HeroProfilePage heading="Reset Password" />

            <div className="login-profile-body container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <div className="row">
                            <div className="col-xs-12 col-md-10 col-lg-6">
                                {state.success ? (
                                    <>
                                        <p className="page-intro">
                                            We've saved your new password.
                                        </p>
                                        <Button
                                            to={Config.routes.login}
                                            style={{ margin: "20px 0" }}
                                        >
                                            Continue to login
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <ServerErrorMessage>
                                            {state.error}
                                        </ServerErrorMessage>
                                        <p className="page-intro">
                                            Enter a new password for your
                                            account
                                        </p>
                                        <ReactForm
                                            onSuccess={handleFormSubmit}
                                            validators={customValidators}
                                            disableSubmitUntilValid
                                        >
                                            <ReactFormField
                                                type="password"
                                                name="password"
                                                required={true}
                                                validators={["utspassword"]}
                                                errorMessages={{
                                                    required:
                                                        "Please enter a new password.",
                                                }}
                                                label="Create password"
                                            />
                                            <Button
                                                type="submit"
                                                styles={["green"]}
                                                aria-label="Save Password"
                                            >
                                                Save Password
                                            </Button>
                                        </ReactForm>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ResetPassword;
